import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import {
  DialogActionType,
  EdtellDialogComponent,
  EdtellDialogData,
  EdtellFormControl,
  EdtellFormGroup,
  NotificationService,
  SrsCheckboxConfig,
  SrsFormState,
} from "@edtell-common";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";
import { CatalogCourseOverview } from "src/app/modules/catalog/interfaces/catalog-course-overview.interface";
import { CourseOverviewDetail } from "src/app/modules/catalog/interfaces/course-overview-detail.interface";
import { EdtellFrontFacingDialogConfig } from "src/app/modules/edtell-common/edtell-containers/interface/edtell-front-facing-dialog-config.interface";
import { ShoppingCartService } from "../../../services/shopping-cart.service";

@Component({
  selector: "app-review-courses-dialog",
  templateUrl: "./review-courses-dialog.component.html",
  styleUrls: ["./review-courses-dialog.component.scss"],
})
export class ReviewCoursesDialogComponent
  extends EdtellDialogComponent
  implements OnInit
{
  dialogData: EdtellDialogData;
  formGroup = new EdtellFormGroup(SrsFormState.WRITE, {});
  objectTitle: string;

  create(reqBody: any): Observable<any> {
    return null;
  }
  update(reqBody: any): Observable<any> {
    return null;
  }
  delete(id: number): Observable<any> {
    return null;
  }

  frontFacingDialogConfig: EdtellFrontFacingDialogConfig = {
    header: () => {
      let header = "";
      switch (this.step) {
        case 1:
          header = "Review Your Courses";
          break;
        case 2:
          header = "Review Your School Information";
          break;
        case 3:
          header = "Enter Your Contact Information";
          break;
        case 4:
          header = "Confirmation & Payment";
          break;
      }
      return header;
    },
    edtellDialogRef: this,
  };

  step: 1 | 2 | 3 | 4 | 5 = 1;

  constructor(
    public dialogRef: MatDialogRef<ReviewCoursesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EdtellDialogData,
    public notificationService: NotificationService,
    private shoppingCartService: ShoppingCartService,
  ) {
    super(data.action as DialogActionType, notificationService);
    this.dialogData = data;
  }

  dialogOnInit() {}

  initForm() {}

  async incrementStep(checkForChanges = true) {
    const errorResponse = await this.shoppingCartService
      .checkRegistrationError()
      .pipe(first())
      .toPromise();
    if (errorResponse == "cancel") {
      return;
    }
    if (errorResponse == "new registration") {
      this.shoppingCartService.clearShoppingCart();
      this.dialogRef.close();
      return;
    }
    let complete = false;
    if (checkForChanges) {
      complete = await this.shoppingCartService
        .checkRegistrationForChanges()
        .pipe(first())
        .toPromise();
    }

    if (!complete) {
      this.step++;
    }
  }

  async decrementStep() {
    const errorResponse = await this.shoppingCartService
      .checkRegistrationError()
      .pipe(first())
      .toPromise();
    if (errorResponse == "cancel") {
      return;
    }
    if (errorResponse == "new registration") {
      this.shoppingCartService.clearShoppingCart();
      this.dialogRef.close();
      return;
    }
    const complete = await this.shoppingCartService
      .checkRegistrationForChanges()
      .pipe(first())
      .toPromise();

    if (!complete) {
      this.step--;
    }
  }
}
